import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { finalize, Observable } from 'rxjs';
import { inject, Injectable } from '@angular/core';
import { LoaderService } from '../../shared/services/loader.service';
import { Endpoints } from '../../shared/utils/logistique-pn';
import { CONFIG } from '../config/config.token';

@Injectable()
export class LoaderInterceptor implements HttpInterceptor {
  private readonly loaderExcludedEndpoints: string[] = [
    Endpoints.LogActivitiesLatestHistoryDate,
    Endpoints.CarRentalLatestOrderDate,
    Endpoints.LogActivitiesGetPointsParameters,
    Endpoints.HotelOrdersLatestHistoryDate,
  ];

  private readonly refreshCalculationEndpoints: string[] = [Endpoints.RefreshCalculation];

  private readonly config = inject(CONFIG);
  private readonly loaderService = inject(LoaderService);

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    if (!req.url.startsWith(this.config.api_url)) {
      return next.handle(req);
    }

    // extract the endpoint
    const endpoint = req.url.replace(this.config.api_url, '');

    if (this.refreshCalculationEndpoints.includes(endpoint)) {
      this.loaderService.setMessage('mealTray.tableOrders.calculationLoading');
      this.loaderService.showLoader();
    } else if (!this.loaderExcludedEndpoints.includes(endpoint)) {
      this.loaderService.setMessage('general.loading');
      this.loaderService.showLoader();
    }

    return next.handle(req).pipe(
      finalize(() => {
        if (!this.loaderExcludedEndpoints.includes(endpoint)) {
          this.loaderService.hiddenLoader();
        }
      }),
    );
  }
}
